<template>
  <div class="category-page bg-white">
    <page-skeleton>
      <template slot="header-left">
        <el-button size="medium" type="primary" round @click="addCategory">添加品类</el-button>
      </template>
      <template slot="header-right">
        <template v-if="parameter.type == 2">
          <!-- <el-button size="medium" round @click="importHandle">导入</el-button> -->
          <el-button size="medium" round @click="exportHandle(1)">导出品类</el-button>
          <el-button size="medium" round @click="exportHandle(2)">导出品类商品</el-button>
        </template>
        <el-popover
          placement="bottom-end"
          width="400"
          trigger="click">
          <el-table :data="sortList">
            <el-table-column width="250" property="fullName" label="品类名称"></el-table-column>
            <el-table-column width="120" label="排序" v-slot="{ row }">
              <el-input type="number" v-model="row.sort" :min="1" size="medium" placeholder="请输入排序" @blur="$set(row, 'sort', +row.sort>1?row.sort:1)" />
            </el-table-column>
          </el-table>
          <el-button size="medium" type="primary" @click="setProductCategorySort" style="display:block;margin:10px auto 0">确认</el-button>
          <el-button slot="reference" size="medium" type="primary" round @click="getProductCategorySort">首页合集排序</el-button>
        </el-popover>
      </template>

      <template slot="container">
        <el-table v-loading="loading" :key="tableKey" :data="tableData" ref="multipleTable" style="width: 100%" height="100%"
          :row-key="(row) => row.id+''"
          :tree-props="{ children: 'childList' }"
          :expand-row-keys="expands"
          @expand-change="expandChange">
          <el-table-column width="140">
            <div slot-scope="{row}" class="sort-icon" :style="{left: `calc(${2 * row.level}0% - ${(row.level-1)*10}px)`}">
              <i class="iconfont icon-line-height a-icon" />
            </div>
          </el-table-column>
          <el-table-column v-for="(item, index) in tableData[0] && tableData[0].language" :key="item.languageId" show-overflow-tooltip>
            <template #header>
              {{ item.languageName === '通用英语' ? '品类名称' : item.languageName }}
            </template>
            <template v-slot="{ row }">
              {{ row.language[index] && row.language[index].name ? row.language[index].name : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="图片" v-slot="{ row }">
            <el-popover placement="right" width="280" trigger="hover">
              <el-image :src="row.imgUrl" fit="cover" />
              <el-image slot="reference" :src="row.imgUrl" fit="cover" class="stock-img" />
            </el-popover>
          </el-table-column>

          <el-table-column prop="isMain" v-slot="{ row }" label="首页展示">
            <el-checkbox :value="!!row.isMain" @change="(e) => handleCheckChange(e, row)"></el-checkbox>
          </el-table-column>

          <el-table-column prop="status" v-slot="{ row }" label="导航展示">
            <el-checkbox :value="!!row.status" @change="(e) => setCategoryShow(e, row)"></el-checkbox>
          </el-table-column>

          <el-table-column prop="num" label="商品数量" show-overflow-tooltip />
          <el-table-column v-slot="scope" label="操作" width="120">
            <!-- <el-button type="text" size="medium" @click="() => addChildrenCategory(scope.row)">添加子品类</el-button>
            <el-button type="text" size="medium" @click="() => editCategory(scope.row)">编辑</el-button>
            <el-button type="text" size="medium" @click="() => deleteCategory(scope.row)">删除</el-button> -->
            <el-button type="text" size="medium" @click="() => editCategory(scope.row)">编辑</el-button>
            <el-dropdown style="margin-left:10px" @command="(e) => handleCommand(e, scope.row)" trigger="click">
              <span class="el-dropdown-link">
                <el-button type="text" size="medium">更多</el-button>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="1">商品排序</el-dropdown-item>
                <el-dropdown-item :command="2">添加子品类</el-dropdown-item>
                <!-- <el-dropdown-item :command="3">删除</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </el-table-column>
        </el-table>
      </template>

      <template #footer-right>
        <el-pagination background :current-page="parameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="parameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </template>

      <!-- 添加/编辑品类 -->
      <el-dialog :title="`${title}品类`" :visible.sync="categoryDialogVisible" width="60%" :before-close="closeCategoryDialog" class="addOrEdit">
        <el-form ref="form" label-position="right" :model="form" :rules="rules" label-width="90px">
          <div class="flex-container">
            <template v-for="(item, key) of form">
              <el-form-item v-if="key !== '页面描述'" style="width: 50%;" :key="key" :label="key+':'" :prop="key === '通用英语' ? '通用英语' : key === '网址' ? '网址' : key === 'SEO标题' ? 'SEO标题' : ''">
                <el-upload v-if="key === '图片'" class="category-uploader" action="#" :show-file-list="false" :before-upload="beforeCategoryUpload">
                  <img v-if="form[key]" :src="form[key]" class="category" />
                  <i v-else class="el-icon-plus category-uploader-icon" />
                  <div v-if="form[key]" slot="tip" class="el-upload-tip" @click="deleteCategoryImg">删除</div>
                </el-upload>
                <div v-else-if="key === '通用英语'" class="f--c">
                  <el-input v-model.trim="form[key]" size="medium" :maxlength="50" :placeholder="`请输入${key}`" @input="handleInput(key)" style="width:550px" />
                  <div style="flex-shrink: 0;padding:0 10px">{{ form[key]?form[key].length:0 }}/50</div>
                </div>
                <div v-else-if="key === '网址'" class="f--c site-url">
                  <div style="flex-shrink: 0;">{{ kakaUrl }}</div>
                  <el-input :disabled="title !== '添加' && title !== '添加子'" v-if="readonly" v-model="form[key]" size="medium" placeholder="请输入网址关键词" @input="handleInput(key)" style="width:256px" />
                  <span v-else>{{ form[key] }}</span>
                  <i class="pointer iconfont el-icon-document-copy" @click="handleCopy"></i>
                </div>
                <div v-else-if="key.includes('SEO')||key==='通用英语' || key==='页面标题'" class="f--c">
                  <el-input v-model="form[key]" size="medium" :maxlength="key=='通用英语'?50:key=='SEO标题'?150:key=='页面标题'?80:key=='SEO关键词'?200:300" :placeholder="`请输入${key}`" style="width:550px" />
                  <div style="flex-shrink: 0;padding:0 10px">{{ form[key]?form[key].length:0 }}/{{ key=='通用英语'?50:key=='SEO标题'?150:key=='页面标题'?80:key=='SEO关键词'?200:300 }}</div>
                </div>
         
                 <!-- <el-input v-else-if="key==='页面描述'" type="textarea" v-model="form[key]" size="medium" :placeholder="`请输入11111${key}`" style=" display: none; width:550px" /> -->
                <el-input v-else v-model="form[key]" size="medium" :placeholder="`请输入${key}`"/>
              </el-form-item>
            </template>
            <el-form-item label="页面描述:" prop="页面描述">
              <rich-editor :value="form['页面描述']" style="width:100%" @input="inputRichEditorValue"/>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" @click="closeCategoryDialog">取 消</el-button>
          <el-button size="medium" type="primary" @click="confirmDialogVisible">确 定</el-button>
        </span>
      </el-dialog>

      <set-product-sort ref="setProductSort" />
    </page-skeleton>

    <import-excel ref="importExcel" :confirmLoading="confirmLoading" @download="download" @import="importAffirm" />
  </div>
</template>

<script>
import API from '@/api'
// import { getPathName } from '@/utils'
import { copy } from '@/utils'
import PageSkeleton from './components/PageSkeleton.vue'
import SetProductSort from './components/SetProductSort.vue'
import ImportExcel from '@/components/ImportExcel.vue'
// import Sortable from 'sortablejs'
import { createSortTable } from '@/views/js/treeSortable'
import RichEditor from '@/views/operation/copywriting/components/RichEditor.vue'
import _ from 'lodash'

export default {
  name: 'supply_category',
  components: {
    RichEditor,
    'page-skeleton': PageSkeleton,
    'set-product-sort': SetProductSort,
    ImportExcel
  },
  data() {
    return {
      loading: false,
      parameter: {
        pageSize: 20,
        pageNumber: 1,
        type: '2' // 1 旧品类, 2新品类
      }, // 获取品类列表的请求参数

      tableData: [], // 表格数据源
      radio: undefined,
      checked: [], // 选择类目，最多4条
      total: 0, // 分页总条数

      title: undefined, // 添加/编辑品类对话框的标题
      categoryDialogVisible: false, // 控制添加/编辑品类对话框的显示与隐藏
      form: {}, // 添加/编辑品类对话框中表单的绑定值
      languages: [], // 语言列表数据
      rules: {
        // 添加/编辑品类对话框中表单的验证对象
        通用英语: [
          { required: true, message: '请输入通用英语的材质', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符之间', trigger: 'blur' }
        ],
        SEO标题: [
          { required: true, message: '请输入SEO标题', trigger: 'blur' },
        ],
        网址: [
          { required: true, message: '请输入网址', trigger: 'blur' },
        ]
      },

      readonly: this.$store.getters.userRole === "4",
      editRow: {}, // 当前编辑的行
      editData: [],

      sortList: [],
      expands: [], // 指定展开ids
      sortable: null, // sortable对象
      tiledTable: [], // 平铺table数据
      tableKey: '', // 刷新table
      confirmLoading: false, // 导入弹窗确认
      bodyWrapperScrollTop: 0, // 表格移动的位置

      
      kakaUrl: process.env.VUE_APP_KAKACLO_URL+'/product-list/'
    }
  },
  created() {
    this.getCategoryList()
  },
  mounted() {
    
  },
  methods: {
    // 初始化拖拽表格
    initSortTable() {
      const el = this.$refs.multipleTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      const _this = this
      this.sortable = createSortTable(el, this.tiledTable, (oldIndex, newIndex) => {
        let param = { type: 2 }
        _this.tiledTable.forEach((item, i) => {
          if (i === oldIndex) param = { ...param, position: item.orderNum, id: item.id }
          else if (i === newIndex) param = { ...param, targetPosition: item.orderNum, targetId: item.id }
        })

        API.sortProductDragOrder(param).then(res => {
          if (res.code !== 10000) return _this.$message.error(res.message)
          _this.getCategoryList()
          
        })
      })
    },

    // 品类列表
    async getCategoryList(call = true) {
      this.loading = true
      if (this.$refs.multipleTable) {
        // 记录列表操作前位置
        this.bodyWrapperScrollTop = this.$refs.multipleTable.bodyWrapper.scrollTop
      }
      if (this.sortable && this.sortable.el) {
        this.sortable.destroy()
      }
      try {
        if (call) this.resetPage()
        let { data } = await API.getCategoryList(this.parameter)
        this.deleteChildren(data.list)
        this.total = data.total
        this.tableData = data.list
        // 设置位置
        this.setScroll()
        // 平铺树结构
        let arr = []
        const tileArr = (list) => {
          list.forEach(item => {
            arr.push(item)
            if (item.childList && item.childList.length) {
              return tileArr(item.childList)
            }
          })
          return arr
        }
        this.tiledTable = tileArr(data.list).map((item, i) => ({ ...item, sort: i }))
        this.tableKey = new Date().getTime()
        this.$nextTick(() => {
          this.initSortTable()
        })
      } catch (error) {
        throw new Error(error.message)
      }
      // this.$tableScrollTop()
    },
    resetPage() {
      this.parameter.pageNumber = 1
    },
    deleteChildren(list) {
      list.forEach((item) => {
        if (!item.childList.length) {
          delete item.childList
        } else {
          if (item.isMain === 1) {
            this.radio = item.categoryId
          }
          this.deleteChildren(item.childList)
        }
      })
    },

    // 获取语言列表
    async getPublicSelectData() {
      let { data } = await API.getPublicSelectData({ type: 1, param: undefined })
      this.languages = data
      this.$set(this.form, '图片', undefined)
      data.forEach((item) => {
        this.$set(this.form, item.name, undefined)
        this.$set(this.form, 'SEO标题', undefined)
        this.$set(this.form, 'SEO描述', undefined)
        this.$set(this.form, 'SEO关键词', undefined)
        this.$set(this.form, '网址', undefined)
        this.$set(this.form, '页面标题', undefined)
        this.$set(this.form, '页面描述', undefined)
      })
    },

    // 添加品类
    addCategory() {
      this.title = '添加'
      this.categoryDialogVisible = true
      this.getPublicSelectData()
    },

    // 设置品类默认展示字段单选框的回调
    async changeRadioGroup(row) {
      this.radio = row.categoryId
      let result = await API.categoryDefaultExhibition({ categoryId: row.categoryId, isMain: 1 }) // isMain: 0.未选中 1.选中
      if (result.code === 10000) {
        this.$message.success(result.message)
      } else {
        this.$message.error(result.message)
      }
      this.getCategoryList(false)
    },

    // 添加子品类
    addChildrenCategory(row) {
      this.editRow = row
      this.title = '添加子'
      this.categoryDialogVisible = true
      this.getPublicSelectData()
    },

    // 编辑品类
    async editCategory(row) {
      this.editRow = row
      this.title = '编辑'
      this.categoryDialogVisible = true
      await this.getPublicSelectData()
      let { data } = await API.editCategory(row.categoryId)
      this.editData = data.language
      data.language.forEach((item) => {
        Object.keys(this.form).forEach((key) => {
          if (key === item.languageName) {
            this.form[key] = item.name
          }
        })
      })
      this.form['图片'] = this.editData[0].imgUrl
      this.form['SEO标题'] = data.seoTitle || ''
      this.form['SEO描述'] = data.seoDescription || ''
      this.form['SEO关键词'] = data.seoKeyWords || ''
      this.form['网址'] = data.categoryUrl || ''
      this.form['页面标题'] = data.pageTitle || ''
      this.form['页面描述'] = data.pageDescription || ''
    },

    // 删除品类
    async deleteCategory(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let { code } = await API.deleteCategory(row.categoryId)
          if (code === 10000) {
            this.$message.success('删除成功')
            this.getCategoryList()
          } else {
            this.$message.error('删除失败')
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    // 添加/编辑品类对话框中上传文件之前的钩子
    beforeCategoryUpload(file) {
      API.signValue({ directory: 'test/' }).then(({ data }) => {
        let formData = new FormData()
        formData.append('directory', 'test/')
        formData.append('signValue', data)
        formData.append('fileList', file)
        API.uploadFile(formData).then((result) => {
          if (result.code !== 10000) {
            return this.$message.error(result.message)
          }
          this.form['图片'] = result.data
        })
      })
      return false
    },

    // 添加/编辑品类对话框中删除已上传的上传文件
    deleteCategoryImg() {
      this.form['图片'] = undefined
    },

    // 添加/编辑品类对话框关闭事件的回调
    closeCategoryDialog() {
      this.form = {}
      this.editRow = {}
      this.editData = []
      this.title = undefined
      this.categoryDialogVisible = false
    },

    // 添加/编辑品类对话框确认事件的回调
    confirmDialogVisible() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        let arr = []
        Object.keys(this.form)
          .filter((item) => {
            return !['图片', 'SEO标题', 'SEO描述','SEO关键词', '网址','页面标题','页面描述'].includes(item)
            // item !== '图片'
          })
          .forEach((key, index) => {
            if (this.languages[index].name === key && this.form[key]) {
              if (this.title === '添加') {
                arr.push({
                  parentId: 0,
                  languageId: this.languages[index].code,
                  level: 1,
                  name: this.form[key],
                  imgUrl: undefined
                })
              } else if (this.title === '添加子') {
                arr.push({
                  parentId: this.editRow.categoryId,
                  languageId: this.languages[index].code,
                  level: this.editRow.level + 1,
                  name: this.form[key],
                  imgUrl: undefined
                })
              } else if (this.title === '编辑') {
                arr.push({
                  id: this.editData[index].id,
                  languageId: this.languages[index].code,
                  name: this.form[key],
                  imgUrl: undefined
                })
              }
            }
          })
        arr.forEach((item) => {
          item.imgUrl = this.form['图片']
          item.seoTitle = this.form['SEO标题']
          item.seoDescription = this.form['SEO描述']
          item.pageTitle = this.form['页面标题']
          item.pageDescription = this.form['页面描述']
          item.seoKeyWords = this.form['SEO关键词']
          item.categoryUrl = this.form['网址']
        })

        if (this.title === '添加' || this.title === '添加子') {
          let result = await API.newlyAddedCategory(arr.map(item => ({ ...item, type: this.parameter.type })))
          if (result.code === 10000) {
            this.$message.success(result.message)
            this.closeCategoryDialog()
            this.getCategoryList(false)
          } else {
            this.$message.error(result.message)
          }
        } else if (this.title === '编辑') {
          let result = await API.confirmEditCategory(arr)
          if (result.code === 10000) {
            this.$message.success(result.message)
            this.closeCategoryDialog()
            this.getCategoryList(false)
          } else {
            this.$message.error(result.message)
          }
        }
      })
    },

    // 每页显示条数发生改变时的回调
    handleSizeChange(size) {
      this.parameter.pageSize = size
      this.getCategoryList(false)
    },

    // 上一页/下一页/当前页发生改变时的回调
    handleCurrentChange(current) {
      this.parameter.pageNumber = current
      this.getCategoryList(false)
    },

    handleCommand(command, row) {
      // if (command === 1) return this.$refs.setProductSort.show(row.categoryId)
      if (command === 1) {
        // TODO 新需求 => 跳转到新商品排序页面
        this.$router.push(`/supply/good-sort?categoryId=${row.categoryId}&firstCategoryId=${row.firstCategoryId}`)
      }
      if (command === 2) return this.addChildrenCategory(row)
      if (command === 3) return this.deleteCategory(row)
    },

    // 设置首页展示
    handleCheckChange(e, row) {
      API.categoryDefaultExhibition({ categoryId: row.categoryId, isMain: e ? 1 : 0 }).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
          this.getCategoryList()
        } else this.$message.error(res.message)
      })
    },
    // 设置导航展示
    setCategoryShow(e, row) {
      API.setProductCategoryShow({ categoryId: row.categoryId, status: e ? 1 : 0 }).then((res) => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.getCategoryList()
      })
    },

    // 获取排序列表
    getProductCategorySort() {
      API.getProductCategorySort({ type: this.parameter.type }).then(res => {
        this.sortList = res.data
      })
    },
    setProductCategorySort() {
      let param = this.sortList.map(item => ({ categoryId: item.categoryId, id: item.id, sort: item.sort }))
      API.setProductCategorySort(param).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.getProductCategorySort()
      })
    },
    handleTabClick() {
      this.getCategoryList()
    },

    // 导入
    importHandle() {
      this.$refs.importExcel.show()
    },
    // 导出
    exportHandle(exportType) {
      this.importExportFile({
        fileType: 2,
        taskType: 16,
        condition: JSON.stringify({ type: '2', exportType })
      })
    },
    // 下载模板
    download() {
      API.getSystemImport({ dictTypeCode: 'data:category_download_template' }).then(res => {
        window.open(res.data)
      })
    },
    importAffirm(filePath) {
      this.confirmLoading = true
      this.importExportFile({
        fileType: 1,
        taskType: 1,
        fileName: this.$store.getters.userId,
        filePath
      })
    },
    // 导入导出
    importExportFile(param) {
      API.importExportFile(param).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message) 
        this.$refs.importExcel.close()
        this.$message.success('操作成功，请到导入导出管理查看')
      }).finally(() => {
        this.confirmLoading = false
      })
    },

    // 展开指定行
    expandChange(row, expands) {
      if (expands) this.expands.push(row.id+'')
      else this.expands.splice(this.expands.indexOf(row.id+''), 1)
    },
    // 设置table位置
    setScroll() {
      this.$nextTick(()=> {
      setTimeout(() => {
        let scrollTop = this.$refs.multipleTable.bodyWrapper
        scrollTop.scrollTop = this.bodyWrapperScrollTop
        this.loading = false
        }, 0)
      })
    },
    handleCopy() {
      copy(this.kakaUrl+this.form['网址'])
    },
    handleInput(key) {
      let value = this.form[key]
      if (key === '通用英语') {
        value = value.replace(/[^\w'-\s&]/ig,'')
      } else {
        value = value.replace(' ','-')
        value = value.replace(/[^\w\/-]/ig,'')
      }
      this.$set(this.form, key, value)
    },
      // 富文本主体内容
    inputRichEditorValue(value) {
      this.form['页面描述'] = value
    }
  }
}
</script>

<style lang="scss" scoped>
.category-page {
  /deep/ .el-tabs__header{
    margin-bottom: 0;
    .el-tabs__nav-scroll{
      padding-left: 20px;
    }
  }

  /deep/ .page-skeleton {
    section {
      height: calc(100vh - 220px);
    }
  }

  /deep/ .el-table__cell .cell {
    position: relative;
    min-height: 20px;
    display: flex;
    .sort-icon {
      width: 26px;
      position: absolute;
    }
  }

  .a-icon {
    display: inline-block;
    color: #afbbca;
    font-size: 20px;
    margin-right: 15px;
    cursor: move;
    user-select: none;
    &:hover {
      color: var(--PC);
    }
  }
}

.stock-img {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #f5f7fa;
  user-select: none;
  cursor: pointer;
}

.el-form {
  height: 580px;
  overflow: auto;
}

.category-uploader {
  /deep/.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    vertical-align: text-bottom;
    &:hover {
      border-color: #99c41c;
    }
  }
  .category-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 108px;
    height: 108px;
    line-height: 108px;
    text-align: center;
  }
  .category {
    display: block;
    width: 108px;
    height: 108px;
    object-fit: cover;
  }
  .el-upload-tip {
    color: #99c41c;
    width: 108px;
    margin-top: 0;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    user-select: none;
    cursor: pointer;
    &:hover {
      color: #f56c6c;
    }
  }
}

.site-url {
  /deep/ input {
    padding-left: 2px;
  }

  .el-icon-document-copy {
    margin: 0 10px;
  }
}

.addOrEdit /deep/ .el-form {
  height: 500px;
}
.flex-container {
  display: flex;
  flex-wrap: wrap; /* 允许弹性项目换行 */
  align-items: center; /* 将项目在交叉轴上居中对齐 */
  height: 200px;
  margin-right: 10px;

}
/deep/.el-dialog__body {
  overflow: hidden;
}
</style>
